import { render, staticRenderFns } from "./ActionProcessUnknownEkp.vue?vue&type=template&id=2ceb548a&scoped=true&"
import script from "./ActionProcessUnknownEkp.vue?vue&type=script&lang=js&"
export * from "./ActionProcessUnknownEkp.vue?vue&type=script&lang=js&"
import style0 from "./ActionProcessUnknownEkp.vue?vue&type=style&index=0&id=2ceb548a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ceb548a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VTextarea})
